export type PrintedPageData = {
  colorCount: number;
  backSide: number;
};

export type FormData = {
  quantity: number;
  printedPagesData: PrintedPageData[];
  barcode: number;
};

export type QuoteFormData = {
  fullName: string;
  email: string;
  phoneNumber: string,
  message: string;
};

export enum InfoAlert {
  MAX,
  MIN
}